import { getIsApiPending } from '../../../selectors/eaTravelRates/auth';
import { apiTransitionAuthLogin, authLoginSuccess, setShowOtpScreenValue } from '../../../actions/eaTravelRates/auth';
import axios from 'axios';
import { getAccessToken, getAuthForm } from '../../../selectors/eaTravelRates/auth';

function wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

export const authLoginService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionAuthLogin.pending());
            try {
                const resp = await calculate(store.getState());

                //cater for nodemailer delay
                await wait(8000);

                store.dispatch(authLoginSuccess(resp.data));
                store.dispatch(apiTransitionAuthLogin.success());
                store.dispatch(setShowOtpScreenValue(true));
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionAuthLogin.failure());
            }
        }
    })();
    return next(action);
};

const payload = (state) => {
    const auth = getAuthForm(state);

    const payload = {
        emailAddress: auth.email.value,
    };

    return {
        ...payload,
    };
};

const calculate = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ea-travel-rates/auth-login';
        return await axios.post(url, payload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
